export function safeJsonParse<T>(jsonString: string): T | null {
  try {
    return JSON.parse(jsonString);
  } catch {
    return null;
  }
}

export function safeJsonParseOrValue<E, A = E>(json: A | string): E | A {
  try {
    return JSON.parse(String(json));
  } catch {
    return json as A;
  }
}
